import React, { useState } from "react";
import { Navbar, NavbarContent } from "@nextui-org/react";
import { Link, useLocation } from "react-router-dom";
import "../../../view/pages/products/products.css";

const CustomNavbar = () => {
  const location = useLocation();
  const [isOpen, setIsOpen] = useState(false);

  // Dynamic active path detection for nested routes
  const getActivePath = () => {
    const pathname = location.pathname;
    if (pathname === "/products") return "/products";
    if (pathname.startsWith("/controller/") || pathname.startsWith("/productdetails/")) return "/controller";
    if (pathname.startsWith("/controllercard")) return "/controllercard";
    if (pathname.startsWith("/solarmotor")) return "/solarmotor";
    if (pathname.startsWith("/pumps")) return "/pumps";
    if (pathname.startsWith("/ats")) return "/ats";
    if (pathname.startsWith("/inverter")) return "/inverter";
    if (pathname.startsWith("/rms")) return "/rms";
    return pathname;
  };

  const activeLink = getActivePath();

  const handleLinkClick = (path) => {
    setIsOpen(false);
  };

  const navbarLinks = [
    { path: "/products", label: "Products >>", activeKey: "/products" },
    { path: "/controller", label: "Solar Pump Controllers", activeKey: "/controller" },
    { path: "/controllercard", label: "Controller Card", activeKey: "/controllercard" },
    { path: "/solarmotor", label: "Motor", activeKey: "/solarmotor" },
    { path: "/pumps", label: "Pumps", activeKey: "/pumps" },
    { path: "/ats", label: "Automatic Transfer Switch", activeKey: "/ats" },
    { path: "/inverter", label: "Inverter", activeKey: "/inverter" },
    { path: "/rms", label: "RMS", activeKey: "/rms" }
  ];

  return (
    <div className="relative w-full">
      <Navbar isBordered variant="sticky" className="productnavber w-full px-4">
        {/* Desktop View */}
        <div className="hidden md:flex w-full items-center justify-between">
          <NavbarContent className="content1 flex space-x-4">
            <Link
              to="/products"
              className={`font-semibold transition-colors ${
                activeLink === "/products" ? "text-blue-600" : "text-gray-700 hover:text-blue-500"
              }`}
              onClick={() => handleLinkClick("/products")}
            >
              Products &gt;&gt;
            </Link>

            <NavbarContent className="content2 w-full flex items-center space-x-2">
              {navbarLinks.slice(1).map((link) => (
                <React.Fragment key={link.path}>
                  <Link
                    to={link.path}
                    className={`transition-colors ${
                      activeLink === link.activeKey ? "text-blue-600 font-semibold" : "text-gray-700 hover:text-blue-500"
                    }`}
                    onClick={() => handleLinkClick(link.path)}
                  >
                    {link.label}
                  </Link>
                  <span className="text-gray-400">&gt;&gt;</span>
                </React.Fragment>
              ))}
            </NavbarContent>
          </NavbarContent>
        </div>

        {/* Mobile View - Hamburger Menu */}
        <div className="md:hidden w-full flex flex-col space-y-2 p-2">
          <div className="flex justify-between items-center">
            <span className="font-bold text-lg">Products</span>
            <button onClick={() => setIsOpen(!isOpen)} className="md:hidden">
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
              </svg>
            </button>
          </div>
          
          {isOpen && (
            <div className="flex flex-col space-y-2 mt-2">
              {navbarLinks.map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  className={`py-2 px-4 rounded-lg transition-colors ${
                    activeLink === link.activeKey 
                      ? "bg-blue-100 text-blue-600 font-semibold" 
                      : "text-gray-700 hover:bg-gray-100"
                  }`}
                  onClick={() => handleLinkClick(link.path)}
                >
                  {link.label}
                </Link>
              ))}
            </div>
          )}
        </div>
      </Navbar>
    </div>
  );
};

export default CustomNavbar;
